import React from 'react';

import config from '@plone/volto/registry';

import { normalizeImageItem } from '../../../helpers/rewriteBackendUrl';

const PreviewImagePT = ({ item, className, alt, imageField, ...rest }) => {
  const PreviewImage = config.getComponent({ name: 'PreviewImage' }).component;
  const normalizedItem = normalizeImageItem(item);
  if (normalizedItem[imageField]?.data) {
    return (
      <img
        src={`data:${normalizedItem[imageField]['content-type']};base64,${normalizedItem[imageField].data}`}
        alt={alt}
        className={className}
        loading="lazy"
        {...rest}
      />
    );
  } else {
    let image_field =
      normalizedItem[imageField]?.scales || normalizedItem.image_scales
        ? imageField
        : null;
    if (normalizedItem.image_scales) {
      normalizedItem[imageField] =
        normalizedItem.image_scales[imageField][0];
    }

    return (
      <PreviewImage
        item={normalizedItem}
        alt={alt}
        className={className}
        imageField={image_field}
        image_field={image_field}
        responsive={true}
        loading="lazy"
        {...rest}
      />
    );
  }
};

export default PreviewImagePT;
